import { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import Hero from "../components/hero";
import XLPOffers from "../components/xlp_offers";
import StudentReviews from "../components/student_reviews";

class XlpIndividualStudents extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const { isLoggedIn } = this.props;
    return (
      <>
        <div>
          <Header isLoggedIn={isLoggedIn} />

          <Hero
            title={
              <>
                Learn What
                <br />
                Matters. Build Skills
                <br />
                That Last.
              </>
            }
            description="Choose from a wide range of expert-led courses across technology, creativity, and career skills. Start learning instantly and get guided support whenever you need it."
            buttonText="Explore Courses"
            buttonLink="/xlp_for_schools_screen"
            imageSrc="assets-webp/misc/laptop.webp"
            background="linear-gradient(to bottom, #f0f4f8 0%, #ffffff 100%)"
            imageStyle={{
              maxWidth: "800px",
              aspectRatio: "16 / 9",
              objectFit: "contain",
            }}
          />

          <StudentReviews />

          <XLPOffers
            title="Our Approach"
            description="XLP gives every student a clear and exciting learning journey. Once they enroll, they get access to their own digital learning world inside the XLP app."
            imageSrc="assets-webp/flowcharts/flowchart-approach.webp"
          />

          <Hero
            title={
              <>
                Learning Come Alive
                <br />
                With Smart Insights
              </>
            }
            description="A unified student dashboard that blends analytics, assessments, and personalized insights—helping educators track growth, strengthen skills, and guide students toward future-ready excellence."
            titleColor="#2d3436"
            buttonText="Sign Up Now"
            buttonLink="/contact_screen"
            imageSrc="assets-webp/misc/insights-image.webp"
            background="linear-gradient(to bottom, #f0f4f8 0%, #ffffff 100%)"
            imageStyle={{
              maxWidth: "800px",
              aspectRatio: "16 / 9",
              objectFit: "contain",
            }}
          />

          <Footer />
        </div>
      </>
    );
  }
}

export default XlpIndividualStudents;
